{
  "AgentAdvanced_Fields_LicenceType": "Centro de atendimento ao cliente Tipo de licença:",
  "AgentAdvanced_Fields_InternalNumber": "Número interno:",
  "AgentAdvanced_Fields_CiscoCommonID": "Cisco Common Identity:",
  "AgentAdvanced_Fields_OverrideMonitoring": "Monitorização de anulação:",
  "AgentAdvanced_Fields_WebexCallingUserID": "ID de utilizador de chamada Webex:",
  "AgentAdvanced_Fields_BroadworksUserID": "ID de utilizador BroadWorks:",
  "AgentAdvanced_Fields_TeamsUserID": "ID de utilizador do MS Teams:",
  "AgentAdvanced_Fields_UserPrincipalName": "Nome principal do utilizador (URN):",
  "AgentAdvanced_Fields_OwningGroupID": "ID do grupo proprietário:",
  "AgentAdvanced_Fields_OIDOnTelephoneServer": "OID no servidor telefónico:",
  "AgentAdvanced_Fields_OwningDepartment": "Departamento proprietário (caminho completo):",
  "CallCentreLicenceTypes_None": "[Nenhum]",
  "CallCentreLicenceTypes_Basic": "Básico",
  "CallCentreLicenceTypes_Standard": "Padrão",
  "CallCentreLicenceTypes_Premium": "Prémio",
  "NAME": "AgentAdvanced"
}